<template>
  <component :is="currentTheme" />
  <Main v-if="isDefault && icpMsg" :msg="icpMsg" :beianLink="beianLink" :beianCode="beianCode" />
  <div v-else-if="icpMsg" class="footer">
    <a :href="beianLink" rel="noreferrer" target="_blank" class="b" v-if="beianLink">
      <img src="./assets/beian.png" class="badge-icon" alt="" />
      津公网安备{{ beianCode }}号
    </a>
    <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener" class="b">
      <img src="./assets/icp.png" class="badge-icon" alt="" />
      {{ icpMsg }}
    </a>
  </div>
</template>

<script>
import Main from "./components/index.vue";
import { getCurrentTheme } from "./themes/themeConfig";

const ICP_PREFIX = "黑ICP备16003321号-";
const BEIAN_LINK = "https://beian.mps.gov.cn/#/query/webSearch?code=";

const SITE_CONFIG = {
  "zhangjifu.cn":    { icp: "7", beian: "12010302002825", title: "儒虎添艺" },
  "zhangjifu.com":   { icp: "4", beian: "12010302002827", title: "旅游记录" },
  "geeph.tech":      { icp: "4", beian: "12010302002826", title: "旅游记录" },
  "jifuzhang.cn":    { icp: "4", beian: "12010302002824", title: "旅游记录" },
  "jifuzhang.com":   { icp: "4", beian: "12010302002524", title: "旅游记录" },
  "geeph.me":        { icp: "1", beian: "12010302002828", title: "个人生活记录" },
  "geephzhang.com":  { icp: "1", beian: "12010302002523", title: "个人生活记录" },
};

function getHost() {
  return window.location.hostname.replace(/^www\./, "");
}

function getConfig() {
  return SITE_CONFIG[getHost()] || {};
}

export default {
  name: "App",
  components: {
    Main,
  },
  data() {
    return {
      currentTheme: null,
    };
  },
  computed: {
    icpMsg() {
      const cfg = getConfig();
      return cfg.icp ? ICP_PREFIX + cfg.icp : "";
    },
    beianCode() {
      return getConfig().beian || "";
    },
    beianLink() {
      return this.beianCode ? BEIAN_LINK + this.beianCode : "";
    },
    isDefault() {
      return this.currentTheme && this.currentTheme.name === "ThemeDefault";
    },
  },
  async mounted() {
    document.title = getConfig().title || "儒虎添翼";
    const theme = getCurrentTheme();
    const mod = await import(`./themes/${theme.name}.vue`);
    this.currentTheme = mod.default;
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: rgba(22, 22, 41, 0.7);
}

html,
body,
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.b {
  color: sandybrown;
  font-size: xx-small;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  height: 10px;
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 8px;
}

.badge-icon {
  width: 10px;
  height: 10px;
  margin-right: 4px;
  flex-shrink: 0;
}
</style>
